<template>
  <v-container
    id="enrollerSummary"
  >
    <v-progress-linear
      v-show="loading"
      indeterminate
      color="green"
    />
    <div>
      <div class="oe-summary-title">
        <v-btn
          class="mx-2"
          fab
          dark
          x-small
          :color="approvals.color"
          @click="displaySection = !displaySection"
        >
          <v-icon
            v-show="!displaySection"
            dark
          >
            mdi-arrow-expand-vertical
          </v-icon>
          <v-icon
            v-show="displaySection"
            dark
          >
            mdi-arrow-expand-horizontal
          </v-icon>
        </v-btn>
        Enroller Summary
      </div>
      <v-fab-transition>
        <note
          v-show="displaySection"
          :open-enrollment="openEnrollment"
          :section="sections.enrollers"
          summary="true"
        />
      </v-fab-transition>
      <v-container
        v-if="!loading && enrollers && enrollers.length"
        fluid
      >
        <v-row dense>
          <v-col
            v-for="(enroller, i) in enrollers"
            :key="i"
          >
            <v-fab-transition>
              <v-card
                v-show="displaySection"
                class="enroller-summary"
              >
                <v-card-text>
                  <div class="display-2 text--primary">
                    <span v-text="enroller.fullName" />
                  </div>
                  <base-display-value
                    v-model="enroller.carrier"
                    label="Carrier"
                    class="mt-2"
                  />
                  <base-display-value
                    v-model="enroller.writingNumber"
                    label="Writing #"
                    class="mt-2"
                  />
                </v-card-text>
              </v-card>
            </v-fab-transition>
          </v-col>
        </v-row>
      </v-container>
      <v-fab-transition>
        <v-alert
          v-show="displaySection && (!loading && (!enrollers || !enrollers.length))"
          type="info"
        >
          No enroller details found
        </v-alert>
      </v-fab-transition>
      <v-fab-transition>
        <approval
          v-show="displaySection"
          :approvals="approvals"
          :allow-change="!print"
          @approval:changed="$emit('approval:changed')"
        />
      </v-fab-transition>
    </div>
    <base-material-snackbar
      v-model="displayError"
      type="error"
      v-bind="{
        top: true,
        right: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'
  import Approvals from '@/services/troody/Approvals'

  export default {
    name: 'EnrollerSummary',

    components: {
      Note: () => import('./Note'),
      Approval: () => import('./Approval'),
    },

    props: {
      expanded: {
        type: Boolean,
        default: false,
      },
      openEnrollment: {
        type: Object,
        default: null,
      },
      print: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      displaySection: true,

      loadingEnroller: false,

      errorMessage: null,
      displayError: false,
      formErrors: {},

      enrollers: null,

      enrollerResource: new TroodyApi('oeEnroller/'),
      approvals: null,
    }),

    computed: {
      loading () {
        return (this.loadingEnroller)
      },

      sections () {
        return Approvals.sections
      },
    },

    watch: {
      expanded (val) {
        this.displaySection = val
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.formErrors = {}
        this.loadEnroller()
        this.approvals = new Approvals(this.openEnrollment.id, Approvals.sections.enrollers.id)
        this.displaySection = this.expanded
      },

      loadEnroller () {
        this.loadingEnroller = true
        this.enrollerResource.query({ openEnrollmentId: this.openEnrollment.id })
          .then(data => {
            console.log('enroller')
            console.log(data)
            this.loadingEnroller = false
            this.enrollers = data
          })
          .catch((error) => {
            this.loadingEnroller = false
            this.enrollers = null
            this.showError(error, 'Failed to load enroller details!')
          })
      },

      showError (error, msg) {
        console.log(error)
        this.errorMessage = (error || msg)
        this.displayError = true
      },
    },
  }
</script>

<style lang="sass">
  .enroller-summary
    border-width: 3px
    border-style: solid
    border-color: rgba(0, 255, 0, 0.1) !important
    border-radius: 10px !important
    margin: 4px !important
</style>
